import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	dialogRoot: {
		width           : "fit-content",
		paddingTop      : "5rem",
		backgroundColor : "transparent",
		borderRadius    : "1.5rem",
		boxShadow       : "unset",
		background      : "none"
	},
	closeButton: {
		width    : "2.4rem",
		height   : "2.4rem",
		cursor   : "pointer",
		position : "absolute",
		right    : "1rem",
		top      : "1rem"
	},
	qrCodeContianer: {
		backgroundColor : theme.other.colors.background.primary,
		boxShadow       : theme.other.colors.boxShadow.primary,
		border          : `1px solid ${ theme.other.colors.border.primary }`,
		borderRadius    : "1.5rem",
		overflow        : "hidden"
	}
} ) );
